module.exports = __webpack_public_path__ + "static/media/privacy_lens.163d9c1b.svg";